export default __webpack_public_path__ + "static/color-analysis-neutrals-37f9e47020320e6de8f7ab1c1857b34d.jpg";